import { Component } from '@angular/core';

@Component({
  selector: 'hs-results-hint-modal',
  templateUrl: './results-hint-modal.component.html',
  styleUrls: ['./results-hint-modal.component.scss']
})
export class ResultsHintModalComponent {

}
